import { Component, Switch, Route } from '@mna/react'
import SmoothTransition from '@mna/react-ui/SmoothTransition'
import ScrollTop from '@mna/react-ui/ScrollTop'
import { classnames as cx } from '@mna/react'
var iOSSafari;

class Body extends Component {

  componentDidMount() {
    this.focusScrollContainer()
      var ua = window.navigator.userAgent;
      var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      var webkit = !!ua.match(/WebKit/i);
      iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
  }

  focusScrollContainer = () => {

    // Enable keyboard scroll upon route render

    // https://stackoverflow.com/questions/22109621/keyboard-down-button-does-not-work-when-overflow-is-defined-for-html-body#answer-22126539
    if (!this.scrollContainer
      // If another element is focused already
      || window.document.activeElement
    ) return
    this.scrollContainer.tabIndex = '0'
    this.scrollContainer.focus()
  }

  render() {
    const { children, location, onRouteEnter, footer } = this.props
    return (
      <main id="content"
            className={
                cx("site-main ",
                iOSSafari?"site-main-safari":"",
                (location.pathname.includes('find-care-options/') && !location.pathname.includes('find-care-options/telemedicine-result' ) && !location.pathname.includes('find-care-options/house-visit-result' )  && !location.pathname.includes('find-care-options/concierge-care-result' ) && !location.pathname.includes('find-care-options/done' )) ? 'site-main-width' : ''
                )}
        ref={el => this.scrollContainer = el }
      >
        <SmoothTransition
          className="site-main-body"
          location={location}
          onRouteEnter={newLocation => {
            this.focusScrollContainer()
            onRouteEnter && onRouteEnter(newLocation)
          }}
        >
          {transitLocation =>
            <>
              <ScrollTop pathname={transitLocation.pathname} />
              <Switch location={transitLocation}>
                { children }
              </Switch>
            </>
          }
        </SmoothTransition>
        {footer}
      </main>
    )
  }
}

export default Body
